// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__tcthZ","saveButton":"style_saveButton__9MgEj","saveButtonText":"style_saveButtonText__qUoqM"};